// extracted by mini-css-extract-plugin
export default {"modalBody":"DuplicateAssignmentDialog__modalBody___V57pj","modalFooter":"DuplicateAssignmentDialog__modalFooter___RS7yj"};